module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/home/bravenet_web_services_drag_and_drop_builders.png";